import FileUpload from "./FileUpload";
import GalleryList from "./Gallery/Gallery-List";
import GalleryURL from "./Gallery/Gallery-URL";
import ImageSearch from "./ImageSearch";

const RightEditor = (props) => {
  const { show, toggleRightshow } = props;

  return (
    <>
      {show && (
        <div className="popup_hv right_hv">
          <div
            className="backdropDiv"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              width: "100%",
              height: "100%",
            }}
            onClick={() => {
              toggleRightshow();
            }}
          ></div>
          <div className="cv_popup">
            <button
              type="button"
              className="close_btn"
              onClick={() => {
                toggleRightshow();
              }}
            >
              <i className="fa fa-close"></i>
            </button>

            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Upload
                </button>
                <button
                  className="nav-link"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Media
                </button>
                <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Image URL
                </button>
                <button
                  className="nav-link"
                  id="nav-pixabay-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-pixabay"
                  type="button"
                  role="tab"
                  aria-controls="nav-pixabay"
                  aria-selected="false"
                >
                  Search
                </button>
              </div>
            </nav>
            <div
              className="tab-content h-100  align-items-center"
              id="nav-tabContent"
            >
              <div
                className="tab-pane  text-center fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <FileUpload toggleRightshow={toggleRightshow} />
              </div>

              <div
                className="tab-pane fade m_t_8"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                {/* <h6>Media</h6> */}
                <GalleryList toggleRightshow={toggleRightshow} />
                <div className="text-center pt-5 d-none">
                  <input
                    name=""
                    type="button"
                    className="btn btn3"
                    value="Save & Continue"
                  />
                </div>
              </div>

              <div
                className="tab-pane fade m_t_8"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <GalleryURL toggleRightshow={toggleRightshow} />
              </div>
              <div
                className="tab-pane  text-center fade"
                id="nav-pixabay"
                role="tabpanel"
                aria-labelledby="nav-pixabay-tab"
              >
                <ImageSearch toggleRightshow={toggleRightshow} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RightEditor;
